import { Component, OnInit, OnDestroy, ChangeDetectorRef, inject } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../../services/media-query.service';
import { SecurityService } from '../../../../services/security.service';
import { MenuService } from '../../../../services/menu/menu.service';
import { MenuPanelItem } from '../../../../domain/menu.domain';
import { DataAnalyticsTaggingService } from '../../../../features/data-analytics-tagging/data-analytics-tagging.service';
import { DataAnalyticsTaggingConstants } from '../../../../features/data-analytics-tagging/data-analytics-tagging.constants';
import { IconComponent } from '../../../../components/icon/icon.component';

@Component({
  selector: 'td-wb-menu-toolbar',
  templateUrl: 'menu-toolbar.component.html',
  styleUrls: ['menu-toolbar.component.scss'],
  imports: [
    IconComponent,
    TranslateDirective
  ]
})
export class MenuToolbarComponent implements OnInit, OnDestroy {
  private readonly menuService = inject(MenuService);
  private readonly mediaQueryService = inject(MediaQueryService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly securityService = inject(SecurityService);
  private readonly dataAnalyticsTaggingService = inject(DataAnalyticsTaggingService);

  toolbarLabelsVisible: boolean;
  isDesktop: boolean = true;
  breakpointChangesSubscription: Subscription;

  ngOnInit(): void {
    this.breakpointChangesSubscription = this.mediaQueryService.observe(Breakpoint.GT_LG)
      .subscribe((state: BreakpointState): void => {
        this.isDesktop = state.matches;
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    if (this.breakpointChangesSubscription !== undefined) {
      this.breakpointChangesSubscription.unsubscribe();
    }
  }

  // TODO:: Remove this method once API is changed
  removeIconPrefix(iconId: string): string {
    return iconId.replace('td-wb-icon--', '');
  }

  getUtilityToolbar(): Array<MenuPanelItem> {
    return this.menuService.getUtilityToolbar(this.isDesktop);
  }

  hasSearchBar(): boolean {
    return this.securityService.hasPermission('SEARCH');
  }

  onMenuClick(utility: MenuPanelItem): void{
    this.dataAnalyticsTaggingService.emitTaggingEvent(DataAnalyticsTaggingConstants.getLinkClickEventData(`tdw:et:quicklinks:${utility.text}`));
  }
}
